<template>
  <li
    class="border-static-default-mid rounded-md flex flex-col justify-between border border-solid p-24"
  >
    <div>
      <RevTag
        v-if="address.default"
        class="mb-12"
        :label="i18n(translations.default)"
        variant="primary"
      />

      <p v-if="address.label" class="body-1-bold mb-16">
        {{ address.label }}
      </p>

      <div class="flex">
        <IconFactory class="text-static-default-mid mr-8 shrink-0" />

        <div class="mt-4 flex flex-col space-y-2">
          <span class="body-1">
            {{ address.company }}
          </span>

          <span class="body-1">
            {{
              i18n(translations.fullName, {
                firstName: address.firstName,
                lastName: address.lastName,
              })
            }}
          </span>

          <span class="body-1">
            {{ address.addressLine }}
          </span>

          <span v-if="address.addressLine2" class="body-1">
            {{ address.addressLine2 }}
          </span>

          <span class="body-1">
            {{
              i18n(translations.cityWithPostalCode, {
                postalCode: address.postalCode,
                city: address.city,
              })
            }}
          </span>

          <span v-if="address.state" class="body-1">
            {{ address.state }}
          </span>

          <span class="body-1">
            {{ i18n.country(address.country) }}
          </span>
        </div>
      </div>

      <div class="mt-5 flex items-center">
        <IconSmartphone class="text-static-default-mid mr-8" />

        <span class="body-1">
          {{ phoneNumber }}
        </span>
      </div>
    </div>

    <slot name="actions" />
  </li>
</template>

<script setup lang="ts">
import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import {
  type CountryOptionType,
  getPhoneNumberAsNational,
} from '@ds/components/InputPhone'
import { RevTag } from '@ds/components/Tag'
import { IconFactory } from '@ds/icons/IconFactory'
import { IconSmartphone } from '@ds/icons/IconSmartphone'

import translations from './AddressCard.translations'

const props = defineProps<{
  address: merchantsAPI.Address
}>()

const i18n = useI18n()

const phoneNumber =
  getPhoneNumberAsNational(
    props.address.phoneNumber,
    props.address.country as CountryOptionType['value'],
  ) || props.address.phoneNumber
</script>
